
module.service('FileService', FileService);

var COOKIE_NAME = 'file_downloading'

// @ngInject
function FileService($q, $document, $cookies, $interval) {

    this.downloadFile = downloadFile;

    function downloadFile(url, tags) {
        var iframe = createIframe(getUrl(url, tags));
        return monitorIframe(iframe);
    }

    function getUrl(baseUrl, tags) {
        return baseUrl + "?" + buildQueryString(flattenTags(tags));
    }

    function createIframe(url) {
        var iframe = $document[0].createElement('iframe');
        iframe.src = url;
        iframe.style.display = 'none';
        createCookie();
        $document[0].body.appendChild(iframe);
        return iframe;
    }

    function removeIframe(iframe) {
        removeCookie();
        $document[0].body.removeChild(iframe);
    }

    function monitorIframe(iframe) {
        var defer = $q.defer();
        var intervalPromise = $interval(function(count) {
            if (!cookieExists()) {
                $interval.cancel(intervalPromise);
            }
        }, 250, 75);

        intervalPromise.then(
            defer.reject, // The max count was reached, this is prob and error
            defer.resolve, // The cookie was removed, file is done.
            defer.notify);

        intervalPromise.finally(function() {
            removeIframe(iframe);
        });

        return defer.promise;
    }

    function cookieExists() {
        return !!$cookies.get(COOKIE_NAME);
    }

    function createCookie() {
        $cookies.put(COOKIE_NAME, 'true');
    }

    function removeCookie() {
        $cookies.remove(COOKIE_NAME);
    }

}

function buildQueryString(parts) {
    return parts.map(function(part) {
        return part[0] + '=' + encodeURIComponent(part[1]);
    }).join('&');
}

function flattenTags(tags) {
    return Object.keys(tags).reduce(function(parts, slug) {
        if (tags[slug] === true) { return parts; }
        return parts.concat(tags[slug].map(function(value) {
            return [slug, value];
        }));
    }, []);
}